import { apiFetch } from './client';

export const FEE_CONFIG_ERRORS = {
  amounts_must_be_non_negative: 'All amounts must be zero or greater.',
  invalid_amounts: 'Enter valid numbers for the fee amounts.',
};

export function normalizeFeeConfig(raw) {
  const config = raw?.config || raw || {};
  return {
    baseFee: config.delivery_fee ?? 40,
    freeDeliveryThreshold: config.free_delivery_min_subtotal ?? 500,
    currency: config.currency || 'INR',
    perKmFee: config.per_km_fee ?? 0,
    maxDeliveryRadiusKm: config.max_delivery_radius_km ?? 0,
    gstInclusive: !!config.gst_inclusive,
  };
}

function toPayload(data) {
  return {
    delivery_fee: Number(data.baseFee),
    free_delivery_min_subtotal: Number(data.freeDeliveryThreshold),
    currency: data.currency || undefined,
    per_km_fee: data.perKmFee !== undefined && data.perKmFee !== '' ? Number(data.perKmFee) : undefined,
    max_delivery_radius_km: data.maxDeliveryRadiusKm !== undefined && data.maxDeliveryRadiusKm !== '' ? Number(data.maxDeliveryRadiusKm) : undefined,
  };
}

export async function getFeeConfig(token) {
  const raw = await apiFetch('/config/checkout', { token });
  return normalizeFeeConfig(raw);
}

export async function updateFeeConfig(data, token) {
  const raw = await apiFetch('/config/checkout', {
    method: 'PUT',
    token,
    body: toPayload(data),
  });
  return normalizeFeeConfig(raw);
}
